import {XmlTagInfo} from './xmlTagProvider'

interface Dictionary<T> {
    [value:string]: T
}

interface Label {
    value: number,
    inputText: string,
    label: string
}

type Type = "number"|"text";

export default class Variable {

    private constructor(
        public name:string,
        private labels: Dictionary<Label>,
        public type?: Type
    ) { }

    static createEmpty(name: string, type: Type = "text"): Variable {
        return new Variable(name, <Dictionary<Label>>{}, type);
    }

    static fromXML(node: XmlTagInfo): Variable {
        let type: Type|undefined;
        if( node.attributes['type'] === "text" || node.attributes['type'] === "number" ) {
            type = <Type> node.attributes['type'];
        }
        const labels = node.children.map(node => {
            return {
                value: parseInt(node.attributes['value']),
                inputText: node.attributes['inputText'],
                label: node.value
            }
        }).reduce((acc, item) => {
            acc[item.value] = item;
            return acc;
        }, <Dictionary<Label>>{});
        return new Variable(
            node.attributes['name'],
            labels,
            type
        );
    }

    getLabel(value: string): string {
        const label = this.labels[value];
        return label ? label.label : ''; // consider undefined
    }

    getInputText(value: string): string|undefined { // consider use same return type as getLabel()
        const label = this.labels[value];
        return label ? label.inputText : undefined;
    }

    isText(): boolean {
        return this.type === "text";
    }
}